import { isPriceCategoryIdDto, type AccommodationDto } from '@hcr/api/consumer'

export const isFlyAccommodation = ({ prices }: AccommodationDto): boolean =>
  prices.some(
    price =>
      isPriceCategoryIdDto(price.category_id) && price.category_id === 'accommodation' && price.market_code === 'FLY'
  )
